import { render, staticRenderFns } from "./Joystick.vue?vue&type=template&id=cd789a6e&scoped=true&"
import script from "./Joystick.vue?vue&type=script&lang=js&"
export * from "./Joystick.vue?vue&type=script&lang=js&"
import style0 from "./Joystick.vue?vue&type=style&index=0&id=cd789a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd789a6e",
  null
  
)

export default component.exports